import React from "react";
import {
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton, TelegramIcon, TelegramShareButton,
  TwitterIcon,
  TwitterShareButton, WhatsappIcon, WhatsappShareButton
} from "react-share";
import {Button} from "reactstrap";
import {toast} from "react-toastify";
import {LinkShareButton} from "./LinkShareButton";

export const SocialShare = ({url})=>{
  return (
    <>
      <FacebookShareButton style={{marginRight:10}} url={url}>
        <FacebookIcon size={32} round={true}/>
      </FacebookShareButton>
      <TwitterShareButton  style={{marginRight:10}} url={url}>
        <TwitterIcon size={32} round={true}/>
      </TwitterShareButton>
      <LinkedinShareButton  style={{marginRight:10}} url={url}>
        <LinkedinIcon size={32} round={true}/>
      </LinkedinShareButton>
      <TelegramShareButton  style={{marginRight:10}} url={url}>
        <TelegramIcon size={32} round={true}/>
      </TelegramShareButton>
      <WhatsappShareButton  style={{marginRight:10}} url={url}>
        <WhatsappIcon size={32} round={true}/>
      </WhatsappShareButton>
    <LinkShareButton className={'react-share__ShareButton'} url={url}>
    </LinkShareButton>
    </>
  )
}
